import chroma from 'chroma-js'

export const getColorShades = (color: string): [string, string][] => {
  const shades = chroma.scale(['#fff', color, '#000']).mode('lab')
    .colors(10)

  const [
    [primary100Hex, primary100Rgb],
    [primary200Hex, primary200Rgb],
    [primary500Hex, primary500Rgb],
    [primary700Hex, primary700Rgb],
  ] = [
    [shades[1], chroma(shades[1]).rgb()],
    [shades[2], chroma(shades[2]).rgb()],
    [color, chroma(color).rgb()],
    [shades[7], chroma(shades[7]).rgb()],
  ]

  return [
    ['--wl-primary-color-100', primary100Hex || ''],
    ['--wl-primary-color-200', primary200Hex || ''],
    ['--wl-primary-color-500', primary500Hex || ''],
    ['--wl-primary-color-700', primary700Hex || ''],

    ['--wl-primary-color-100-rgb', primary100Rgb.join(' ')],
    ['--wl-primary-color-200-rgb', primary200Rgb.join(' ')],
    ['--wl-primary-color-500-rgb', primary500Rgb.join(' ')],
    ['--wl-primary-color-700-rgb', primary700Rgb.join(' ')],
  ]
}
